module.exports = __webpack_public_path__ + "static/lato-light-656963c4beb814e754e38478fcaa0439.woff";